import i18n from "../../../../../constants/i18n";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";
import getKhattabat101MGeneralStore from "../../../../../stores/khattabat-stores/101m-stores/general-101m-store";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3TextArea from "../../../../../core/et3-input/et3-text-area";

const MessageToSend = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { unitX, colors } = theme;
  const isArabicMatchAppLanguage =
    getKhattabatMatchingStore().matchAppLanguage.get().value === "AR";

  return (
    <Et3TextArea
      width={1400}
      height={120}
      containerStyle={{
        borderRadius: 10 * unitX,
        border: `1px solid ${colors.all.gray}`
      }}
      textFieldStyle={{
        direction: isArabicMatchAppLanguage ? "rtl" : "ltr"
      }}
      rowsNumber={4}
      message={getKhattabat101MGeneralStore().messageToSendToCreated101M.get()}
      placeHolder={i18n.get("SEND_ONE_O_ONE_M_MESSAGE_PLACE_HOLDER")}
      onChange={(value: string) =>
        getKhattabat101MGeneralStore().setMessageToSendToCreated101M(value)
      }
    />
  );
});

export default MessageToSend;
